module.exports = __webpack_public_path__ + "static/media/NewDesignHrUp2.ab6e8738.svg";